var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-service-plan"},[_c('div',{class:_vm.isPreview ? 'btn-open-manual-preview' : 'btn-open-manual'},[_c('img',{attrs:{"src":"/images/_SVGs/plano_de_servico.svg","alt":_vm.config.alt,"onload":"SVGInject(this)"}}),_c('span',[_vm._v(_vm._s(_vm.config.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }